import { gql } from '@apollo/client'
import { MUTATION_STATE } from 'api/fragments'

const PAYLOAD_TYPE = 'StopVoohCampaignPayload'

export const STOP_VOOH_CAMPAIGN = gql`
  ${MUTATION_STATE(PAYLOAD_TYPE)}
  mutation stopVoohCampaign($id: ID!) {
    stopVoohCampaign(input: { id: $id }) {
      ...MutationState${PAYLOAD_TYPE}Fields
    }
  }
`
